/* React */
import React, { useCallback, useRef } from 'react';
import { Link } from 'react-router-dom';

/* Styles */
import {
  Container,
  ContentWrapper,
  Content,
  ProfilePicture,
  RightContainer,
} from './styles';

/* antd */
import { Form, message, Input } from 'antd';

/* Hooks */
import { useAuth } from '../../hooks/auth';

/* Assets */
import Coruja from '../../assets/img/pet/corujaDedoLevantado.png';

/* Interfaces */
import { SignInCredentials } from '../../interfaces/auth';

/* Components */
import { Header } from '../../components/Header';
import Footer from '../../components/Footer';

/* Icons */
import { FaGoogle, FaFacebookF, FaAppleAlt } from 'react-icons/fa';
import { ImSpinner2 } from 'react-icons/im';

interface ProfileProps {}

const Profile: React.FC<ProfileProps> = () => {
  const {
    handleSignIn,
    SignInWithGoogle,
    SignInWithFacebook,
    SignInWithApple,
    loadingGoogle,
    setLoadingGoogle,
    loadingFacebook,
    setLoadingFacebook,
    loadingApple,
    setLoadingApple,
  } = useAuth();
  const [form] = Form.useForm();
  const formRef = useRef(null);

  const handleSubmit = useCallback(
    async (data: SignInCredentials) => {
      try {
        await handleSignIn(data);
      } catch (err) {
        message.error('Falha no login');
        return;
      }
    },
    [handleSignIn]
  );

  return (
    <Container>
      <Header />
      <ContentWrapper>
        <Content>
          <ProfilePicture
            urlPhoto={
              'https://static8.depositphotos.com/1003924/886/i/600/depositphotos_8868243-stock-photo-spectrum-multicolored-eye-macro.jpg'
            }
          />
          <RightContainer></RightContainer>
        </Content>
      </ContentWrapper>
      <Footer />
    </Container>
  );
};

export default Profile;
